<div class="buttons" *ngIf="coreConfig.enable3D && show" [class.show]="coreConfig.enable3D">
	<button class="small-icon-button"
			(click)="toggleMapDimentions()"
			tooltip-value="2D / 3D"
			[attr.tooltip-class]="'left'">
		{{ moveToMap }}
	</button>
</div>
